import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-non-compleanno-page',
  templateUrl: './non-compleanno-page.component.html',
  styleUrls: ['./non-compleanno-page.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class NonCompleannoPageComponent implements OnInit {
  showReward: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
